import { TerminalsWrapper } from "../../components";
import AuthService from "../../utilities/services/auth.service";

export default function TerminalsPage() {
  const organization = AuthService.getOrg()?.[0];
  return (
    <>
      <TerminalsWrapper organization={organization} />
    </>
  );
}
